import { Stack, Typography, Tooltip } from '@mui/material';
import { useColors } from 'frontend/hooks/useColors';
import formatSecondsToHours from 'frontend/utils/formatSecondsToHours';
import { getScaleInfo } from 'frontend/utils/getScaleInfo';
import './flightCard.css';

const TooltipScale = ({ escala }) => {
  const { background, coral } = useColors();

  const dotStyle = {
    height: 12,
    width: 12,
    borderRadius: '50%',
    backgroundColor: escala?.isNotScale ? background : coral,
    position: 'relative',
  };

  if (escala?.isNotScale) {
    return <div style={dotStyle} />;
  }

  const getTooltipInfo = (scale) => {
    if (!scale) return [];

    const formattedInfo = getScaleInfo(scale);

    return [
      { text: scale.origin },
      { text: `Tiempo de Espera: ${formatSecondsToHours(scale.waitTime)}` },
      {
        ...formattedInfo,
        color: '#009e00',
      },
    ];
  };

  const info = getTooltipInfo(escala);

  return (
    <Tooltip
      placement="top"
      componentsProps={{
        tooltip: {
          sx: { backgroundColor: 'transparent !important' },
        },
      }}
      title={
        <Stack className="tooltip-scale-container">
          {info.map(({ text, color }, index) => (
            <Typography
              key={`scale-info-${index}`}
              color={color || '#000'}
              fontSize={12}
              fontWeight={300}
            >
              {text}
            </Typography>
          ))}
        </Stack>
      }
    >
      <div style={dotStyle} />
    </Tooltip>
  );
};

export default TooltipScale;
